/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDashboardLayoutItem } from './ReportDashboardLayoutItem';
import type { ReportPropertyInterestRankingFilters } from './ReportPropertyInterestRankingFilters';
import type { ReportWidgetAccentColor } from './ReportWidgetAccentColor';
import type { ReportWidgetValidation } from './ReportWidgetValidation';
/**
 * Persisted property interest ranking widget instance.
 */
export type ReportPropertyInterestRankingWidgetInstance = {
    /**
     * Stable widget instance identifier.
     */
    id: string;
    /**
     * Discriminator for the property interest ranking widget.
     */
    kind: ReportPropertyInterestRankingWidgetInstance.kind;
    /**
     * Optional user-facing title override.
     */
    title?: string;
    /**
     * Optional short badge label shown on the widget card.
     */
    label?: string;
    /**
     * Optional semantic accent color used to tint the widget card and badge.
     */
    color?: ReportWidgetAccentColor;
    /**
     * Saved layout metadata for the widget instance.
     */
    layout: ReportDashboardLayoutItem;
    /**
     * Validation result resolved from the current tenant state.
     */
    validation?: ReportWidgetValidation;
    /**
     * Saved filters for the property interest ranking widget.
     */
    filters: ReportPropertyInterestRankingFilters;
};
export namespace ReportPropertyInterestRankingWidgetInstance {
    /**
     * Discriminator for the property interest ranking widget.
     */
    export enum kind {
        PROPERTY_INTEREST_RANKING = 'PROPERTY_INTEREST_RANKING',
    }
}

